import * as ActionType from "../actionType";
import { fetchOurshowPageApi } from "../../services/page/ourshowpage";

const getOurshowPageAction = () => {
  return async dispatch => {
    dispatchOurshowPage(dispatch);
  };
};

const dispatchOurshowPage = dispatch => {
  fetchOurshowPageApi().then(data => {
    dispatch({
      type: ActionType.RECEIVE_OURSHOW_PAGE,
      data
    });
  });
};

export { getOurshowPageAction, dispatchOurshowPage };



// WEBPACK FOOTER //
// ./src/actions/page/ourshowpage.js